import React from "react";
import { AccountTile } from "./AccountTile";
export var AccountTabTiles = function AccountTabTiles() {
  return React.createElement("div", null, React.createElement(AccountTile, null));
};